import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import StoreHeaderDataProvider from './context-api/StoreHeaderDataProvider';
import LoginDataProvider from './context-api/LoginDataProvider';
import SignUpInfoDataProvider from './context-api/SignUpInfoDataProvider';
import OnTheMenuDataProvider from './context-api/OnTheMenuDataProvider';
import DataProvider from './context-api/DataProvider';
import CheckoutDataProvider from './context-api/CheckoutDataProvider';
import DeliveryAddressDataProvider from './context-api/DeliveryAddressDataProvider';
import GlobalStateDataProvider from './context-api/GlobalStateDataProvider'




//import moment from "moment";
// setTimeout(() => {
//   const currentTime = new Date().getTime();
//   const timeDiffrence = currentTime - (data.data.fetchApiTime)
//   const b = moment(data.data.fetchApiTime);
//   const a = moment(currentTime); // now
//   // const minute = Number(10);
//   const diffrence = a.diff(b, 'seconds');
//   console.log('----check diffrence', diffrence, timeDiffrence)

// }, 5000)



// document.addEventListener('visibilitychange', () => {
//   if (document.hidden) {
//     console.log('$$$$$$$$$$$$$$$$$$$$not visible', new Date());
//   } else {
//     console.log('$$$$$$$$$$$$$$$$$$$is visible', new Date());
//   }
// });



// document.addEventListener("visibilitychange", (event) => {
//   if (document.visibilityState == "visible") {
//     console.log("tab is active")
//   } else {
//     console.log("tab is inactive")
//   }
// });


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <GlobalStateDataProvider>
      <DataProvider>
        <StoreHeaderDataProvider>
          <DeliveryAddressDataProvider>
            <LoginDataProvider>
              <SignUpInfoDataProvider>
                <OnTheMenuDataProvider>
                  <CheckoutDataProvider>
                    <App />
                  </CheckoutDataProvider>
                </OnTheMenuDataProvider>
              </SignUpInfoDataProvider>
            </LoginDataProvider>
          </DeliveryAddressDataProvider>
        </StoreHeaderDataProvider>
      </DataProvider>
    </GlobalStateDataProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
